/* eslint-disable react/prop-types */
import classNames from 'classnames';
import DatePicker from 'components/base/DatePicker';
import React from 'react';
import { Form } from 'react-bootstrap';
import { formatDate } from 'services/utils';
import InformationTooltip from '../ui/InformationTooltip';

const LabelDateSelector = ({
  controlId,
  required,
  label,
  labelProps,
  labelClass,
  formik,
  dateProps,
  dateOptions,
  errorProps,
  information
}) => {
  const handleOnChange = date => {
    if (date) {
      const dateFormate = dateOptions?.datePostFormate;
      formik.setFieldValue(
        controlId,
        dateFormate
          ? formatDate(date[0], dateFormate)
          : formatDate(date, 'YYYY-MM-DD')
      );
    } else {
      formik.setFieldValue(controlId, '');
    }
  };

  const handleBlur = () => {
    formik.setFieldTouched(controlId, true);
  };

  return (
    <Form.Group className="position-relative" controlId={controlId}>
      <Form.Label
        className={classNames(
          'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium',
          { 'fw-bold': required },
          { 'd-flex flex-between-center': information },
          labelClass
        )}
        {...labelProps}
      >
        {label}
        {required ? '*' : ''}

        {information && (
          <InformationTooltip
            iconProp={{ className: 'fw-bold' }}
            label={information}
          />
        )}
      </Form.Label>

      <DatePicker
        onChange={handleOnChange}
        onClose={handleBlur}
        value={formik.values[controlId]}
        options={{
          maxDate: 'today',
          altFormat: 'd-M-Y',
          altInput: true,
          dateFormat: 'Y-m-d',
          ...dateOptions
        }}
        className={classNames({
          'is-invalid': formik.touched[controlId] && formik.errors[controlId]
        })}
        containerClassName={'custom-flat-picker'}
        {...dateProps}
      >
        <Form.Control.Feedback tooltip type="invalid" {...errorProps}>
          {formik.errors[controlId]}
        </Form.Control.Feedback>
      </DatePicker>
    </Form.Group>
  );
};

export default LabelDateSelector;
